import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Mountain } from 'lucide-react';

export const Splash = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-br from-blue-600 to-purple-600">
      <div className="text-center space-y-8">
        <div className="flex justify-center">
          <div className="bg-white rounded-full p-8 shadow-2xl">
            <Mountain className="size-20 text-blue-600" />
          </div>
        </div>
        
        <div className="space-y-2">
          <h1 className="text-white text-5xl">Boulder Comp</h1>
          <p className="text-blue-100 text-xl">Competition Management</p>
        </div>

        <div className="space-y-4 pt-8">
          <Button 
            onClick={() => navigate('/dashboard')}
            size="lg"
            className="w-64 bg-white text-blue-600 hover:bg-blue-50"
          >
            Enter Admin App
          </Button>
        </div>

        <div className="text-blue-100 text-sm pt-8">
          <p>v1.0.0 • Admin Edition</p>
        </div>
      </div>
    </div>
  );
};